import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import CustomPagination from "examples/CustomPagination/CustomPagination";

// Hooks and Data
import useDealer from "hooks/useDealer";
import dealerTableData from "layouts/dealer/data/dealerTableData";
import { useMaterialUIController } from "context";
import useDashboard from "hooks/useDashboard";
import { debounce } from "lodash";

function Tables() {
  const navigate = useNavigate();
  const { dealerList, getdealerList } = useDealer();
  const { columns, rows } = dealerTableData();
  const [controller] = useMaterialUIController() || [{}];
  const { sidenavColor } = controller;
  const { searchTerm } = useDashboard();

  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [total, setTotal] = useState(0);

  // Function to fetch dealers
  const fetchDealers = () => {
    const query = searchTerm.length >= 3 ? searchTerm : ""; // Apply search only if length >= 3
    getdealerList({ limit, page, search: query });
  };

  // Debounced search function
  const debouncedFetchDealers = debounce(fetchDealers, 500);

  // Initial Load (Mandatory)
  useEffect(() => {
    fetchDealers(); // Always fetch initial data on mount
  }, []);

  // Search & Pagination Updates
  useEffect(() => {
    if (searchTerm.length === 0 || searchTerm.length >= 3) {
      debouncedFetchDealers();
    }
    return () => debouncedFetchDealers.cancel(); // Cleanup debounce
  }, [searchTerm, page, limit]);

  // Update pagination state when dealerList updates
  useEffect(() => {
    if (dealerList.page && dealerList.limit) {
      setPage(dealerList.page);
      setLimit(dealerList.limit);
      setTotalPage(dealerList.pages || 1);
      setTotal(dealerList.total || 0);
    }
  }, [dealerList]);

  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
    getdealerList({ limit: 10, page: newPage });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Dealer Table
                </MDTypography>
                <MDButton onClick={() => navigate("/dealer-management/create")}>
                  Create Dealer
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
            <MDBox
              sx={{ width: "100%", display: "flex", justifyContent: "start", marginTop: "1rem" }}
            >
              <CustomPagination
                totalCount={totalPage}
                currentPage={page}
                onPageChange={handlePageChange}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Tables;
